// extracted by mini-css-extract-plugin
export default {"container":"styles_container__rQZJo","avatar":"styles_avatar__IrWvm","memberName":"styles_memberName__f0ZI4","memberId":"styles_memberId__B605L","tableCol":"styles_tableCol__PPjMI"};